import { createSelector } from 'reselect';

export const getSchema = state => state.schema;
export const getSchemaDescriptors = createSelector(getSchema, state => state.descriptors);
export const getAttributes = createSelector(getSchema, state => state.attributes);
export const isPending = createSelector(getSchema, state => state.pending > 0);

export default {
  getSchema,
  getSchemaDescriptors,
  getAttributes,
  isPending,
};
